'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentOney3XAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 85 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.699951,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M58.7689 19.6199C62.6826 19.6199 65.8806 22.8456 65.9045 26.812C65.9045 27.1928 65.8731 27.7446 65.8476 28.0197H54.3018C54.8888 30.6877 57.0355 31.8684 58.825 31.8684C60.2342 31.8684 61.7137 31.2349 62.4977 30.2956L62.5149 30.2754H65.4336C65.4336 30.2754 65.4268 30.3069 65.3961 30.3698C63.9458 33.3384 60.8961 34.385 58.7194 34.385C56.8131 34.385 55.0206 33.6008 53.6623 32.1772C52.328 30.7716 51.5853 28.929 51.5853 26.9889C51.5853 22.8568 54.7428 19.6199 58.7689 19.6199ZM58.7456 22.1327C56.4499 22.1327 54.7428 23.8786 54.3871 25.665H63.0974C62.747 23.8786 61.0398 22.1327 58.7456 22.1327ZM39.5647 26.2085C39.5647 23.4453 40.887 22.0487 43.489 22.0487C46.0894 22.0487 47.4042 23.4453 47.4042 26.2085V34.391H50.0735V26.0166C50.0578 24.548 49.7898 23.5098 49.1967 22.5352C48.4892 21.4407 46.8037 19.5996 43.489 19.5996C40.1652 19.5996 38.485 21.4407 37.7767 22.5352C37.1784 23.5098 36.9186 24.548 36.8931 26.0166V34.391H39.5647V26.2085ZM74.1619 33.3578L79.7933 19.6017H76.9944L72.7714 29.9453L68.5582 19.6017H65.6238L71.3795 33.3608L69.2253 38.6443H72.0017L72.7699 36.7619L74.1619 33.3578ZM23.2291 27.0076C23.2291 29.7364 25.3676 31.8766 27.9957 31.8766C30.6051 31.8766 32.7548 29.7364 32.7548 27.0076C32.7548 24.2774 30.6051 22.1327 27.9957 22.1327C25.3676 22.1327 23.2291 24.2774 23.2291 27.0076ZM20.6248 27.006C20.6248 22.8522 23.8617 19.6017 27.9949 19.6017C32.1183 19.6017 35.3537 22.8522 35.3537 27.006C35.3537 31.156 32.1183 34.411 27.9949 34.411C23.8617 34.411 20.6248 31.156 20.6248 27.006ZM14.3566 28.3776L15.005 29.5283H16.4576L15.1038 27.5313L16.4336 25.5679H14.9803L14.3566 26.6857L13.7329 25.5679H12.281L13.6183 27.5313L12.2563 29.5283H13.7089L14.3566 28.3776ZM7.57795 27.5972C7.57795 28.8132 8.36564 29.6513 9.78529 29.6513C10.877 29.6513 11.8541 29.0186 11.8541 27.9256C11.8541 27.1947 11.4348 26.7262 10.9182 26.5372C11.3779 26.3813 11.7635 25.9128 11.7635 25.2643C11.7635 24.1871 10.8193 23.6533 9.76058 23.6533C8.34093 23.6533 7.73369 24.5162 7.73369 25.4937H9.06274C9.06274 24.993 9.22746 24.6556 9.79352 24.6556C10.1791 24.6556 10.4502 24.861 10.4502 25.2966C10.4502 25.7156 10.278 26.0035 9.6872 26.0035H9.16981V27.0305H9.6872C10.3102 27.0305 10.5325 27.3506 10.5325 27.8274C10.5325 28.2217 10.2615 28.5838 9.76882 28.5838C9.26041 28.5838 8.90699 28.2217 8.90699 27.5972H7.57795ZM4.54478 26.9839C4.54478 22.8414 7.77343 19.5999 11.8961 19.5999C16.009 19.5999 19.2362 22.8414 19.2362 26.9839C19.2362 31.1242 16.009 34.3702 11.8961 34.3702C7.77343 34.3702 4.54478 31.1242 4.54478 26.9839Z",
          fill: "#87BC2B"
        }
      )
    ]
  }
);
const VpPaymentOney3XAsset = forwardRef(PaymentOney3XAsset);

export { VpPaymentOney3XAsset as default };
